import type { ObservationDeleteSidePanelProps } from "./observation-delete-side-panel.type";

import { Alert, Button, Divider, Flex, Typography } from "antd";
import { Trans, useTranslation } from "react-i18next";

import { getObservationTitle } from "@/entities/observation";
import { ObservationDeleteRelatedItems } from "@/modules/observation/observation-delete-related-items";

import { useObservationDeleteSidePanel } from "./observation-delete-side-panel.hook";

const { Paragraph } = Typography;

export const ObservationDeleteSidePanel = ({
  observation,
  options,
}: ObservationDeleteSidePanelProps) => {
  const { t } = useTranslation();
  const { isPending, onCancelClick, onDeleteClick } =
    useObservationDeleteSidePanel({ observation, options });

  return (
    <div>
      <Alert
        type="error"
        showIcon
        title={
          <>
            <Trans
              parent={Paragraph}
              i18nKey="observation:delete.sidePanel.description"
              values={{ name: getObservationTitle(observation) }}
              components={{ strong: <strong /> }}
            />
            <ObservationDeleteRelatedItems observation={observation} />
          </>
        }
      />
      <Divider />
      <Flex gap="small">
        <Button onClick={onCancelClick}>{t("global:cancel")}</Button>
        <Button
          danger
          type="primary"
          onClick={onDeleteClick}
          loading={isPending}
        >
          {t("global:delete")}
        </Button>
      </Flex>
    </div>
  );
};
